import { Component, OnInit, Inject, PLATFORM_ID, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { DataServiceService } from 'src/app/services/data-service.service';
import { Result } from 'src/app/models/result';
import { Categories } from 'src/app/models/result-categories';
import { SurveyV2Service } from 'src/app/services/surveyV2.service';
import { Survey } from 'src/app/models/survey';
import { SafePipe } from 'src/app/pipes/safe.pipe';
import { SpinnerComponent } from '../../_components/spinner/spinner.component';

@Component({
    selector: 'app-survey-result',
    templateUrl: './survey-result.component.html',
    styleUrls: ['./survey-result.component.scss'],
    imports:[SafePipe,SpinnerComponent,CommonModule],
     changeDetection: ChangeDetectionStrategy.Default
})
export class SurveyResultComponent implements OnInit {

  surveyResultId: number
  surveyId
  results: Result|null = null;
  loading = true;
  survey:Survey;

  constructor(private route: ActivatedRoute, 
    //private dataservice: DataServiceService
    private surveyV2Service: SurveyV2Service,
    @Inject(PLATFORM_ID) private platformId: Object,
    private cdr:ChangeDetectorRef
  ) { }

  ngOnInit() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.route.params.subscribe(params => {
      //("params",params)
      this.survey = JSON.parse(localStorage.getItem(params.surveyId+"_survey"));
      //console.log("this.survey.guidSurveyResultID",this.survey.guidSurveyResultID);
      //console.log("survey",this.survey )
      this.surveyV2Service.survey_result$(this.survey.guidSurveyResultID).subscribe((resp: Result) => {
        resp.portfolioUrlOnly=resp.portfolioUrlOnly.replace("https://www.ifa.com/","")
        resp.portfolioUrl=resp.portfolioUrl.replace("https://www.ifa.com/","")
        this.results = resp;
      
        //console.log("results",resp)
        //success
// $&("survey-result",this.results)
      }, (error) => //error 
      {
// $&(error)
      }, 
      () => //completion handler    
      {
        this.loading = false;
          this.cdr.detectChanges();
      })

      //this.surveyId = params.surveyId
    })
  }

  printComponent(printResults) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    let printContents = document.getElementById(printResults).innerHTML;
    let originalContents = document.body.innerHTML;

    document.body.innerHTML = printContents;

    window.print();

    document.body.innerHTML = originalContents;
}

}
